import { useCallback, useRef, useState } from 'react';
import useModal from './useModal';

const DEFAULT_AIUTINI_TITLE = 'Aiutini';

/**
 * Wraps useModal with safe helpers for Aiutini lifecycle management.
 * Prevents stale effects from reopening the modal after close.
 */
const useAiutiniModal = (initialState = false) => {
  const {
    isOpen: isModalOpen,
    openWith: openWithBase,
    close: closeModalBase,
    title: modalTitle,
    content: modalContent,
  } = useModal(initialState);

  const [isAiutiniModalOpen, setIsAiutiniModalOpen] = useState(false);
  const isAiutiniModalOpenRef = useRef(isAiutiniModalOpen);
  const isModalOpenRef = useRef(isModalOpen);
  isAiutiniModalOpenRef.current = isAiutiniModalOpen;
  isModalOpenRef.current = isModalOpen;

  const closeModal = useCallback(() => {
    // Block stale modal-refresh effects before state updates commit.
    isAiutiniModalOpenRef.current = false;
    isModalOpenRef.current = false;
    setIsAiutiniModalOpen(false);
    closeModalBase();
  }, [closeModalBase]);

  const showModal = useCallback((data = {}) => {
    const { title = '', content = null } = data;
    isAiutiniModalOpenRef.current = false;
    setIsAiutiniModalOpen(false);
    openWithBase({ title, content });
  }, [openWithBase]);

  const showAiutiniModal = useCallback((content, title = DEFAULT_AIUTINI_TITLE) => {
    isAiutiniModalOpenRef.current = true;
    setIsAiutiniModalOpen(true);
    openWithBase({ title, content });
  }, [openWithBase]);

  const refreshAiutiniModal = useCallback((content, title = DEFAULT_AIUTINI_TITLE) => {
    if (!isAiutiniModalOpenRef.current || !isModalOpenRef.current) return;
    openWithBase({ title, content });
  }, [openWithBase]);

  return {
    isModalOpen,
    modalTitle,
    modalContent,
    closeModal,
    showModal,
    showAiutiniModal,
    refreshAiutiniModal,
    isAiutiniModalOpen,
  };
};

export default useAiutiniModal;
